var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('student-roster-teacher',{attrs:{"ay":_vm.ay,"student-page-route":"CTE/CareerCoachTeacher/StudentPage"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }